import styled, { css } from 'styled-components';
import { VideoRenderer as CoreVideoRenderer } from 'core';
import { Typography } from '@web-chat-core/ui-kit';

//  @media
const media = {
    tablet: '@media screen and (max-width: 800px)',
    mobile: '@media screen and (max-width: 500px)',
    shortScreen: '@media screen and (min-width: 801px) and (max-height: 748px)',
    tabletOrShortScreen: '@media screen and (max-width: 800px), screen and (min-width: 801px) and (max-height: 748px)',
    minHeight480: '@media (min-height: 480px)',
    minHeight552: '@media (min-height: 552px)',
    minHeight801: '@media (min-height: 801px)',
    minWidth552: '@media (min-width: 552px)',
};

export const PreJoinContainer = styled.div`
    flex: 1;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto;
    height: 100%;
    justify-items: center;
    display: grid;

    ${media.minHeight480} {
        padding-top: 10px;
    }

    ${media.minHeight552} {
        padding-top: 20px;
    }

    ${media.minHeight801} {
        padding-top: 40px;
    }

    ${media.shortScreen} {
        padding-top: 10px;
    }

    main {
        flex: 1;
        justify-self: center;
        align-self: flex-start;
        width: 100%;

        ${media.shortScreen} {
            align-self: center;
        }

        ${media.minWidth552} {
            max-width: 900px;
        }

        @media screen and (min-width: 552px) and (max-height: 748px) {
            max-width: 1200px;
        }
    }

    footer {
        font-size: 14px;
        margin-top: 50px;
        margin-bottom: 40px;
    }

    h2 {
        text-align: center;
        margin-top: 30px;
    }

    hr {
        border: 1px solid ${(props) => props.theme.root.colors.basicColors['10%']};
    }
`;

export const VideoContainer = styled.div<{ $isNoVideoTrack: boolean }>`
    position: relative;
    border-radius: 4px;
    width: 100%;
    aspect-ratio: 16 / 9;

    ${({ $isNoVideoTrack }) =>
        $isNoVideoTrack &&
        css`
            background: #2b2c30;
        `}
    ${media.tablet} {
        flex: 1;
        min-height: 0;
    }
`;

export const VideoPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const VideoRenderer = styled(CoreVideoRenderer)`
    border-radius: 4px;
`;

export const NameFieldContainer = styled.div<{ $hasError: boolean }>`
    &:hover:after {
        display: none;
    }

    ${({ $hasError }) =>
        $hasError &&
        css`
            &:after {
                display: block;
                transform: translateX(0) translateY(100%);
                left: 0;
                top: auto;
                bottom: -8px;
                z-index: 2;
            }

            &:hover:after {
                display: block;
            }

            input {
                border: 1px solid ${(props) => props.theme.root.colors.system.dangerFocused};
            }
        `}
`;

export const NameFieldLabel = styled.label`
    display: block;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
`;

export const NameField = styled.input`
    border: 1px solid ${(props) => props.theme.root.colors.basicColors['15%']};
    border-radius: 4px;
    font-size: 16px;
    background-color: transparent;
    color: white;
    padding: 8px;
    width: calc(100% - 16px);

    &:focus-visible {
        border-color: ${(props) => props.theme.root.colors.system.infoDefault};
        outline: none;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
        -webkit-text-fill-color: white;
        transition: background-color 5000s ease-in-out 0s;
    }

    &:-webkit-autofill::first-line,
    &:-internal-autofill-previewed,
    &:-internal-autofill-previewed::first-line {
        -webkit-text-fill-color: white;
        color: white;
    }
`;

export const EmptyNameError = styled(Typography)<{ $isVisible: boolean }>`
    display: block;
    visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
    margin-top: 4px;
`;

export const ControlElements = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    ${media.tablet} {
        justify-content: center;
    }

    ${media.shortScreen} {
        align-self: center;
    }
`;

export const PreJoinPageContent = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 32px;

    ${media.shortScreen} {
        flex-direction: row;
        align-items: center;
    }
`;

export const NameWithControlsWrapper = styled.div`
    margin-top: 32px;
    flex: 1 1 auto;

    ${media.tablet} {
        flex: 0 0 auto;
        margin-top: 16px;
        justify-content: flex-start;
    }

    ${media.mobile} {
        margin-top: 14px;
    }

    ${media.shortScreen} {
        flex-direction: column;
        justify-content: center;
        flex: 0 0 390px;
        margin-top: 0;
    }
`;

export const NameFieldSection = styled.div`
    ${media.shortScreen} {
        padding: 0 75px 0;
    }
`;

export const ControlSection = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    ${media.tabletOrShortScreen} {
        flex-direction: column;
        gap: 12px;
    }
`;
